import { fromJS, Record } from 'immutable';

export const sessionsUiRecord = new Record({
  active: fromJS({
    loader: false,
    error: null
  }),
  historical: fromJS({
    loader: false,
    error: null
  })
});
